import { render, staticRenderFns } from "./CustomPaystubUpload.vue?vue&type=template&id=1b577063"
import script from "./CustomPaystubUpload.vue?vue&type=script&lang=js"
export * from "./CustomPaystubUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports